export default __webpack_public_path__ + "static/media/leonie.79e9d46b.png";